import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

// Handles `#session_id=...` fragment after returning from Emergent Auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback({ onAuthed }) {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        toast.success(`Welcome, ${r.data.name?.split(" ")[0] || "traveler"}!`);
        if (onAuthed) await onAuthed();
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
      } finally {
        // strip hash, return to home
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, onAuthed]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-bone/95">
      <div
        className="bg-white rounded-3xl shadow-deep px-8 py-7 flex flex-col items-center gap-4"
        data-testid="auth-callback-card"
      >
        {/* Brand wordmark — anchors the loading screen to TipLingo */}
        <div className="font-jakarta font-extrabold text-3xl text-navy leading-none">
          Tip<span className="text-orange">Lingo</span>
        </div>

        {/* Animated dots */}
        <div className="flex items-center gap-1.5" aria-hidden="true">
          <span className="w-2 h-2 rounded-full bg-orange animate-bounce" style={{ animationDelay: "0ms" }} />
          <span className="w-2 h-2 rounded-full bg-orange animate-bounce" style={{ animationDelay: "120ms" }} />
          <span className="w-2 h-2 rounded-full bg-orange animate-bounce" style={{ animationDelay: "240ms" }} />
        </div>

        <div className="font-jakarta font-bold text-sm text-navy">
          Signing you in…
        </div>
      </div>
    </div>
  );
}
